import { render, staticRenderFns } from "./getLicense.vue?vue&type=template&id=3fb17a1d&scoped=true&"
import script from "./getLicense.vue?vue&type=script&lang=js&"
export * from "./getLicense.vue?vue&type=script&lang=js&"
import style0 from "./getLicense.vue?vue&type=style&index=0&id=3fb17a1d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb17a1d",
  null
  
)

export default component.exports